module.exports = __webpack_public_path__ + "img/2.14862d1b.jpg";